<template>
  <div>
    <h5 class="text-primary">
      <a
        :disabled="disabled"
        :href="value"
        :target="target"
        rel="noopener noreferrer"
      >{{ text }}</a>
    </h5>
  </div>
</template>
<script>
export default {
  name: 'XnNavItem',
  props: {
    value: { type: String, required: true },
    text: { type: String, required: true },
    newTab: { type: Boolean, default: true },
  },
  computed: {
    disabled () {
      return this.value === '__disabled'
    },
    target () {
      return this.newTab ? '_blank' : ''
    },
  },
}
</script>
<style scoped></style>
